<script>
    import { onMount } from "svelte";
    import {imgUrl} from '../service/common.service';

    let observerCallback = function(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          intersected = true;
          observer.unobserve(imgElement);
        }
      });
    };

    /**
     * Path to placeholder image.
     * @type {string}
     */
    export let placeholder;

    /**
     * Path to image.
     * @type {string}
     */
    export let src;


      /**
     * Image width.
     * @type {string}
     */
     export let width;

    /**
     * Image height.
     * @type {string}
     */
     export let height;


    /**
     * Intrinsic image width.
     * @type {string}
     */
    export let intrinsic_width;
    /**
     * Intrinsic image height.
     * @type {string}
     */
    export let intrinsic_height;


    /**
     * Image element class.
     * @type {string}
     */
     export let ImgClass = "";

    /**
     * Alt image text description for accessibility.
     * @type {string}
     */
    export let alt;

    let imgElement;
    let path;

    let observer;
    let intersected = false;
    let loaded = false;

    $: path = intersected ? imgUrl(src, intrinsic_width, intrinsic_height) : placeholder;

    onMount(() => {
      observer = new IntersectionObserver(observerCallback)
      observer.observe(imgElement);

      return () => {
        observer.unobserve(imgElement);
      };
    });

    function handleLoad() {
      if (!loaded && path === src) {
        loaded = true;
      }
    }
  </script>

  <img
    style="min-width: 80px; max-width: 100px; height: {height}px; object-fit: contain;"
    src={path}
    {alt}
    {width}
    {height}
    {intrinsic_width}
    {intrinsic_height}
    on:load={handleLoad}
    bind:this={imgElement}
    {...$$restProps}
    class="{ImgClass} svelte-lazy-image partner-logo"
    class:svelte-lazy-image--loaded={loaded}
  />
